<div *ngIf="crumbList.length > 0" class="l-align-center">
  &nbsp; | &nbsp;
  <ul class="norm-ul l-flex-wrap t-breadcrumbs">
    <li *ngFor="let crumb of crumbList">{{ crumb | translate }}</li>
  </ul>
</div>
